import React from "react";
import { Leaderboard } from "../components/Leaderboard/Leaderboard";
import { Page } from "../components/Page/Page";
import "./PageLayout.css";

export function LeaderboardPage() {
  return (
    <Page>
      <div className="page-layout page-layout--animated">
        <div className="page-content">
          <Leaderboard />
        </div>
      </div>
    </Page>
  );
}
